import { Form, Formik } from 'formik'
import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Loading from 'custom/assets/loaders/Loading'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import * as Yup from 'yup'
import DashboardService from '../../../services/dashboard.service'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import { useHistory } from 'react-router-dom'
import { carouselCurrentItemSelector, accountsSelector } from '../../../selectors'
import InputError from '../../../components/InputError/InputError'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import NeoCalendar from './../../../components/NeoCalendar/NeoCalendar'
import DetailsIcon from 'custom/assets/accounts/Details.svg'
import {
  MENU_SIDEBAR_KEYS,
  SIDENAV_KEYS,
  RECIPTS_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import moment from 'moment'
import config from "custom/config/environment"

export default function DetailedStatement() {
  const [error, setError] = useState('')
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [reportList, setReportList] = useState([])
  const formatList = ['xlsx', 'pdf']
  const history = useHistory()
  const [accounts, setAccounts] = useState([])
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [dateError, setDateError] = useState(false)
  const accountDetails = useSelector(carouselCurrentItemSelector) || {}
  // const accounts = useSelector(accountsSelector) || []

  useEffect(() => {
    // fetchAccounts()
    getAllRefNumbers()
  }, [])

  //   const fetchAccounts = useCallback(async () => {
  //     try {
  //       const response = await getAllAccounts()
  //       if (response.status === 200) {
  //         const casaAccountList = response.data['accountSummaryDetails'].filter((element) =>
  //           ['U', 'S'].includes(element.accountType),
  //         )
  //         setAccounts(casaAccountList)
  //         setStage(1)
  //       }
  //     } catch (err) {
  //       setError(err)
  //       showModal()
  //       setStage(1)
  //     }
  //   }, [])

  // const getDownload = useCallback(
  //   async (values) => {
  //     try {
  //       setLoading(true)
  //       const reqParams = {
  //         ...values,
  //         accountNumber: accountDetails?.accountNo,
  //       }
  //       await BeneficiaryTransferService.downLoadBiStatement(reqParams)
  //       setLoading(false)
  //     } catch (err) {
  //       var enc = new TextDecoder('utf-8')
  //       var arr = new Uint8Array(err.data)
  //       setLoading(false)
  //     }
  //   },
  //   [accountDetails],
  // )

  const getAllRefNumbers = useCallback(async () => {
    setLoading(true)
    try {
      const response = await DashboardService.GetListofFormat()
      if (response.status === 200) {
        setLoading(false)
        setReportList(response.data['formatList'])
        setStage(1)
      }
    } catch (err) {
      setLoading(false)
    }
  })

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderDetailOptions()
      default:
        return renderDetailOptions()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  // function renderReceiptsViewForm() {
  //   return (
  //     <div className="new-design-form-style">
  //       <Formik
  //         initialValues={{
  //           accountNumber: '',
  //           fromDate: '',
  //           toDate: '',
  //           format: '',
  //           reportName: '',
  //         }}
  //         validationSchema={Yup.object().shape({
  //           // accountNumber: Yup.string().required('Account No. is required'),
  //           fromDate: Yup.date()
  //             .max(new Date(), t(VALIDATION_MESSAGES.FORM_DATE_VALID))
  //             .required(t(VALIDATION_MESSAGES.FORM_DATE_REQUIRED)),
  //           toDate: Yup.date()
  //             .min(Yup.ref('fromDate'), t(VALIDATION_MESSAGES.TO_DATE))
  //             .max(new Date(), t(VALIDATION_MESSAGES.TO_DATE_VALID))
  //             .required(t(VALIDATION_MESSAGES.TO_DATE_REQUIRED)),
  //           format: Yup.string().required(t(VALIDATION_MESSAGES.FORMAT)),
  //           reportName: Yup.string().required(t(VALIDATION_MESSAGES.REPORT_VALID)),
  //         })}
  //         onSubmit={getDownload}>
  //         {({ isSubmitting, errors, touched, handleChange, values }) => (
  //           <Form>
  //             <div className='row'>
  //               {/* <div className='form-group col-12'>
  //                 <NeoInput
  //                   mode='select'
  //                   text={'Account No. *'}
  //                   name='accountNumber'
  //                   onChange={handleChange}
  //                   list={accounts}
  //                   keyValue='accountNo'
  //                 />
  //                 <InputError text={errors.accountNumber} touched={touched.accountNumber} />
  //               </div> */}
  //               <div className='form-group col-12'>
  //                 <NeoInput
  //                   text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.FORM_DATE)}
  //                   name='fromDate'
  //                   type='date'
  //                   disabled={loading}
  //                   onChange={handleChange}
  //                   max={moment(new Date()).format('YYYY-MM-DD')}
  //                   //value={values.fromDate}
  //                 />
  //                 <InputError text={errors.fromDate} touched={touched.fromDate} />
  //               </div>
  //               <div className='form-group col-12'>
  //                 <NeoInput
  //                   text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.TO_DATE)}
  //                   name='toDate'
  //                   type='date'
  //                   disabled={loading}
  //                   onChange={handleChange}
  //                   max={moment(new Date()).format('YYYY-MM-DD')}
  //                   //value={values.toDate}
  //                 />
  //                 <InputError text={errors.toDate} touched={touched.toDate} />
  //               </div>
  //               <div className='form-group col-12'>
  //                 <NeoInput
  //                   mode='select'
  //                   text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.FORMAT)}
  //                   name='format'
  //                   disabled={loading}
  //                   onChange={handleChange}
  //                   keyValue={null}
  //                   list={formatList}
  //                 />
  //                 <InputError text={errors.format} touched={touched.format} />
  //               </div>

  //               <div className='form-group col-12'>
  //                 <NeoInput
  //                   mode='select'
  //                   text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REPORT_NAME)}
  //                   name='reportName'
  //                   disabled={loading}
  //                   onChange={handleChange}
  //                   keyValue={null}
  //                   list={reportList}
  //                 />
  //                 <InputError text={errors.reportName} touched={touched.reportName} />
  //               </div>
  //             </div>

  //             <div className='mt-3'>
  //               {loading ? (
  //                 renderLoading()
  //               ) : (
  //                 <NeoButton type='submit' text={t(RECIPTS_KEYS.DOWNLOAD)} mode='newDesign' />
  //               )}
  //             </div>
  //             <div className='back-cancel-style' onClick={() => history.goBack()}>
  //               {' '}
  //               {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
  //             </div>
  //           </Form>
  //         )}
  //       </Formik>
  //     </div>
  //   )
  // }
  function renderDetailOptions(){
    return(
      <div className='row mb-4 mx-0'>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100 mb-3'
                onClick={()=>history.push("/currentMonth")}
                >
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.CURRENTMOONTH)}</span>
              </button>
            </div>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100 mb-3'
                onClick={()=>history.push("/lastTwoMonth")}
                >
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.LASTTWOMONTH)}</span>
              </button>
            </div>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100 mb-3'
                onClick={()=>history.push("/lastThreeMonth")}
                >
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.LASTTHREEMONTH)}</span>
              </button>
            </div>
            <div className='col-4'>
              <button
                type='button'
                className='btn p-2 detailed-statement-btn w-100'
                onClick={() => setShowDatePicker(!showDatePicker)}
                >
                <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
                <span className='font-weight-600'>{t(MENU_SIDEBAR_KEYS.CUSTOMDATES)}</span>
              </button>
            </div>

            {showDatePicker && (
              <div className='col-12 text-center m-3 calender-container'>
                <NeoCalendar setFromDate={setFromDate} setToDate={setToDate} />
                <div>
                  <NeoButton
                    type='button'
                    mode='newDesign'
                    text={'Ok'}
                    styles={{ fontSize: 14, width: '247px' }}
                    onClick={() => {
                      setShowDatePicker(false)
                      history.push({
                        pathname:'/customDates',
                          state:{
                            customFromDate:fromDate,
                            customToDate:toDate,
                          }
                      })
                    }}
                  />
                  {dateError && (
                    <div className='text-danger'>
                      {!fromDate && !toDate && 'Please select the first day.'}
                      {fromDate && !toDate && 'Please select the last day.'}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
      )
  }
  return (
    <LayoutWithAccountCard breadCumKey='DETAILED_STATEMENT'>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={StatementIcon} alt='statement icon' />
          </div>
          <div className="title-spacing">
            <span className='font-weight-bold'>{t(MENU_SIDEBAR_KEYS.DETAILED_STATEMENT)}</span>
            <span className='header-title-section'>
              <p>View and Download your statement</p>
            </span>
          </div>
        </div>
      </div>
      <div>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
